import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Paginator } from '@app/classes/paginator';
import { AnalyticEvents, FeatureFlag } from '@app/enums';
import { PayrollOffCycleForm } from '@app/modules/forms/payroll/components';
import { PayrollModuleMenuService } from '@app/modules/payroll/services/payroll-module-menu.service';
import { AnalyticService, AuthService, NotifyService } from '@app/services';
import { FeatureService } from '@app/services/feature.service';
import { IndexView } from '@common/views/index/index.view';
import { BadgeType } from '@humi-design-library/components/Badge/types';
import { Payroll } from '@models/payroll/payroll.model';
import { PayrollIndexFields } from '@payroll/constants/payroll-index-fields';
import { PayrollStates } from '@payroll/enums/payroll-state.enum';

@Component({
    templateUrl: './payroll-index.template.html',
    styleUrls: ['./payroll-index.style.scss'],
})
export class PayrollIndexView extends IndexView implements OnInit {
    isLoading = true;
    paginator!: Paginator<Payroll>;
    isUnderMaintenance = false;
    currentlyOpenDialog?: 'CREATE_OFFCYCLE_PAYROLL';

    BADGE_TYPES: Partial<Record<PayrollStates, BadgeType>> = {
        open: 'success',
        pending: 'warning',
    };

    constructor(
        private router: Router,
        private notify: NotifyService,
        private auth: AuthService,
        private analytics: AnalyticService,
        private featureService: FeatureService,
        public payrollModuleMenuService: PayrollModuleMenuService
    ) {
        super();

        this.featureService.has(FeatureFlag.payrollMaintenance).then((hasFlag: boolean) => {
            this.isUnderMaintenance = hasFlag;
        });
    }

    ngOnInit(): void {
        this.paginator = new Paginator(
            Payroll.param('company', this.auth.company.id)
                .where('states', [
                    PayrollStates.Open,
                    PayrollStates.Pending,
                    PayrollStates.Paying,
                    PayrollStates.Processing,
                ])
                .select(PayrollIndexFields),
            { shouldAutoLoadData: true }
        );
        this.paginator.onLoading((isLoading) => (this.isLoading = isLoading));
    }

    onCreate(form: PayrollOffCycleForm): void {
        if (!form.valid) {
            return;
        }

        this.currentlyOpenDialog = undefined;
        this.isLoading = true;

        form.payroll
            .param('company', this.auth.company.id)
            .save()
            .then((newPayroll) => {
                this.router.navigate(['/payroll', 'run', newPayroll.id]);
            })
            .catch((err) => {
                this.isLoading = false;
                this.notify.error(err.message || 'payroll.run.couldNotCreatePayroll');
            });
    }

    showOffCyclePayrollModal(): void {
        this.analytics.trackEvent(AnalyticEvents.PayrollRunPayrollClickCreateOffCyclePayroll);

        this.currentlyOpenDialog = 'CREATE_OFFCYCLE_PAYROLL';
    }
}
